export default __webpack_public_path__ + "static/media/caret.639a25c5.svg";